import * as ngCore from '@angular/core'
import * as ngRxCo from '@ngrx/component-store'

export interface LayoutState {
  presentFilters: boolean
}

/** TODO:  */
@ngCore.Injectable()
export class LayoutStore extends ngRxCo.ComponentStore<LayoutState> {
  /** TODO:  */
  public readonly presentFiltersSg = this.selectSignal(
    state => state.presentFilters,
  )

  constructor() {
    super({ presentFilters: false })
  }
}
